import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateComponent } from './date/date.component';
import { TextComponent } from './text/text.component';
import { NumberComponent } from './number/number.component';
import { SelectComponent } from './select/select.component';
import { MultiselectComponent } from './multiselect/multiselect.component';
import { ArrayTextComponent } from './array-text/array-text.component';
import { TextareaComponent } from './textarea/textarea.component';
import { RecordInputComponent } from './record-input/record-input.component';
import { RecordNaicsInputComponent } from './record-naics-input/record-naics-input.component';
import { SelectConfidentialityComponent } from './select-confidentiality/select-confidentiality.component';
import { MultiSelectDropdownComponent } from './multi-select-dropdown/multi-select-dropdown.component';
import { MAT_MODULES, PRIMENG_MODULES } from '@shared/utils/dependencies';
import { MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { getGlobalDateDisplayFormat } from '@shared/utils/helpers/user-preferences';
import { MiqDateAdapterService } from '@shared/services/miq-date-adapter.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@shared/directives/directives.module';
import { L10nTranslationModule } from 'angular-l10n';
import { SharedPipesModule } from '@shared/pipe/shared-pipes.module';
import { RecordDetailLabelComponent } from './record-detail-label/record-detail-label.component';
import { TranslationModule } from '@miq/utils';
import { SelectedNodesTextPipe } from './record-naics-input/selected-nodes-text.pipe';
import { YearPickerComponent } from './year-picker/year-picker.component';
import { YearInputComponent } from './year-input/year-input.component';
import { MultiSelectGroupsComponent } from './multiselect-groups/multiselect-groups.component';

const MIQ_DATE_FORMATS = {
  parse: {
    dateInput: getGlobalDateDisplayFormat('value'),
  },
  display: {
    dateInput: getGlobalDateDisplayFormat('value'),
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    ...MAT_MODULES,
    ...PRIMENG_MODULES,
    DirectivesModule,
    L10nTranslationModule,
    SharedPipesModule,
    TranslationModule,
    FormsModule,
  ],
  declarations: [
    ArrayTextComponent,
    DateComponent,
    MultiSelectDropdownComponent,
    MultiselectComponent,
    NumberComponent,
    RecordInputComponent,
    RecordNaicsInputComponent,
    SelectComponent,
    SelectConfidentialityComponent,
    TextareaComponent,
    TextComponent,
    RecordDetailLabelComponent,
    SelectedNodesTextPipe,
    YearPickerComponent,
    YearInputComponent,
    MultiSelectGroupsComponent,
  ],
  exports: [
    ...MAT_MODULES,
    ...PRIMENG_MODULES,
    ArrayTextComponent,
    DateComponent,
    MultiSelectDropdownComponent,
    MultiselectComponent,
    NumberComponent,
    RecordInputComponent,
    RecordNaicsInputComponent,
    SelectComponent,
    SelectConfidentialityComponent,
    TextareaComponent,
    TextComponent,
    RecordDetailLabelComponent,
    YearPickerComponent,
    YearInputComponent,
    MultiSelectGroupsComponent,
  ],
  providers: [
    { provide: MAT_MOMENT_DATE_ADAPTER_OPTIONS, useValue: { useUtc: true } },
    { provide: MAT_DATE_FORMATS, useValue: MIQ_DATE_FORMATS },
    { provide: DateAdapter, useClass: MiqDateAdapterService, deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS] },
  ],
})
export class InputsModule {}
